import axios from "axios";
import React, { useEffect, useState } from "react";
import './Portfolio.css'

const Portfolio = () => {
    const [portfolioContent, setPortfolioContent] = useState([]); // Use object, not array

    useEffect(() => {
        const fetchPortfolioContent = async () => {
            try {
                const response = await axios.get(`/api/portfolio/get-content`);


                const customOrder = [
                    "hero",
                    "about",
                    "client_testimonal",
                    "Events",
                    "Cars",
                    "Exterior Photography"
                ];

                const sortedContent = response.data.content.sort(
                    (a,b) => customOrder.indexOf(a.category_type) - customOrder.indexOf(b.category_type)
                );
                setPortfolioContent(sortedContent); // Directly set the content
                console.log(response.data.content);
            } catch (error) {
                console.error("Error fetching portfolio content:", error);
            }
        };

        fetchPortfolioContent();
    }, []);

    return (
        <div className="portfolio-page">
            {portfolioContent.map((category, index)=>(
                <div key={index}>
                   
                    {category.category_type === "hero" && (
                        <div className="port-hero">
                        <div className="port-hero-content">
                            <h1>{category.category_name}</h1>
                            <p>{category.category_content}</p>
                            </div>
                            </div>
                    )}

                       {category.category_type === "about" && (
                        <div className="gallery-section about">
                            {category.photos_url &&
                            Object.values(category.photos_url).map((photo, i) => (
                                <img src={photo} alt="profile" className="profile-pic"></img>
                            ))
                            }
                            <h1>{category.category_name}</h1>
                            <p>{category.category_content}</p>
                            <div className="port-gallery">
                            </div>
                            </div>
                    )}

                        {category.category_type === "client_testimonal" && (
                        <div className="gallery-section cars">
                            <h2>{category.category_name}</h2>
                            <p>{category.category_content}</p>
                            <div className="port-gallery">
                                </div>
                            </div>
                    )}

                    {category.category_type === "Events" && (
                        <div className="gallery-section events">
                            <h2>{category.category_name}</h2>
                            <p>{category.category_content}</p>
                            <div className="port-gallery">
                                {category.photos_url &&
                                Object.values(category.photos_url).map((photo, i) => (
                                    <img key={i} src={photo} alt={`Event ${i+1}`} className="gallery-photo"/>
                                ))
                                }
                                </div>
                            </div>
                    )}
            

                    {/* Cars Section */}
                    {category.category_type === "Cars" && (
                        <div className="gallery-section cars">
                            <h2>{category.category_name}</h2>
                            <p>{category.category_content}</p>
                            <div className="port-gallery">
                                {category.photos_url && 
                                Object.values(category.photos_url).map((photo, i) => (
                                    <img key={i} src={photo} alt={`Event ${i+1}`} className="gallery-photo"/>
                                ))}
                                </div>
                            </div>
                    )}

                       
                    {category.category_type === "Exterior Photography" && (
                        <div className="gallery-section exterior">
                           <h2>{category.category_name}</h2>
                           <p>{category.category_content}</p>
                           <div className="port-gallery">
                            {category.photos_url && 
                            Object.values(category.photos_url).map((photo, i) => (
                                <img key={i} src={photo} alt={`Exterior ${i+1}`} className="gallery-photo"/>
                            ))
                            }
                            </div>
                            </div>
                    )}

            
                    </div>
                    ))}
        </div>
    );
};

export default Portfolio;
